import { useEffect, useState } from "react";
import { normalizeDiscountData } from "../utils/normalizeDiscountData";

const useDiscountFormLoader = (discountId) => {
  const [normalizedData, setNormalizedData] = useState(null);
  const [isLoading, setIsLoading] = useState(!discountId);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Skip fetch if in create mode (no ID)
    if (!discountId) {
      setIsLoading(false);
      return;
    }

    const fetchAndNormalize = async () => {
      try {
        // Discounts have no Firestore collection, so an id can never resolve.
        // Editing an existing discount is unreachable until one exists.
        const discount = null;

        if (!discount) {
          throw new Error("Discount not found");
        }

        const normalized = normalizeDiscountData(discount);
        setNormalizedData(normalized);
      } catch (err) {
        setError(err.message || "Failed to load discount data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchAndNormalize();
  }, [discountId]);

  return { data: normalizedData, isLoading, error };
};

export default useDiscountFormLoader;